// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon__32EoO","Icon--right":"Icon--right__vNaAd","Icon--left":"Icon--left__xkVN-"};